export const contactInfo = [
  {
    id: 1,
    name: 'Email',
    value: 'shadmerhi@gmail.com'
  },
  {
    id: 2,
    name: 'LinkedIn',
    value: 'https://www.linkedin.com/in/shadee-m-a27134ba/'
  },
  {
    id: 3,
    name: 'GitHub',
    value: 'https://github.com/shadeemerhi'
  },
]